

// http://wiki.baidu.com/pages/viewpage.action?pageId=1867562413
export const SELF_TOPIC_HEAD_NAME = 'selfTopicHead'; // 头图模块

export const SELF_TOPIC_IMAGE_NAME = 'selfTopicImage'; // 图片模块-1轮播图样式 2横划图样式 3双列样式 4金刚位样式 5双列特殊样式 19 宽度增加的横划图样式
export const SELF_TOPIC_IMAGE_TYPE_BANNER = 1;
export const SELF_TOPIC_IMAGE_TYPE_HORIZONTAL = 2;
export const SELF_TOPIC_IMAGE_TYPE_DOUBLE_COLUMN = 3;
export const SELF_TOPIC_IMAGE_TYPE_GOLD_ICON = 4;
export const SELF_TOPIC_IMAGE_TYPE_SPECIAL_DOUBLE_COLUMN = 5;
export const SELF_TOPIC_IMAGE_TYPE_SWIPER = 15; // 视频轮播图样式
export const SELF_TOPIC_IMAGE_TYPE_SEAMLESS_SPLICING = 18; // 无缝拼接图
export const SELF_TOPIC_BIG_WIDTH_TYPE_HORIZONTAL = 19; // 大宽度的横划图样式

export const SELF_TOPIC_TOFU_CUBE_NAME = 'selfTopicTofuCube'; // 豆腐块模块


export const SELF_TOPIC_CONTENT_NAME = 'selfTopicContent'; // 内容模块
export const SELF_TOPIC_CONTENT_TYPE_HORIZONTAL = 6; // 单行横划样式
export const SELF_TOPIC_CONTENT_TYPE_FLOW_SMALL = 7; // 单列小图信息流
export const SELF_TOPIC_CONTENT_TYPE_FLOW_BIG = 8; // 单列大图信息流
export const SELF_TOPIC_CONTENT_TYPE_SINGLEABS = 16; // 单列摘要样式 TODO

export const SELF_TOPIC_BAR = 'selfTopicBar'; // 底部bar样式
export const SELF_TOPIC_BAR_TYPE_ICON = 9;
export const SELF_TOPIC_BAR_TYPE_ELLIPTICAL = 10; // 单列摘要样式 TODO

export const SELF_TOPIC_CONTAINER = 'selfTopicContainer'; // 容器模块
export const SELF_TOPIC_CONTAINER_TYPE_H = 11; // 横滑 tab
export const SELF_TOPIC_CONTAINER_TYPE_V = 12; // 竖向卡片
export const SELF_TOPIC_CONTAINER_TYPE_MIX = 17; // 平滑

export const SELF_TOPIC_NAVI = 'selfTopicNavi'; // 导航模块
export const SELF_TOPIC_NAVI_HORIZONTAL = 13;
export const SELF_TOPIC_NAVI_VERTICAL = 14;

export const SELF_TOPIC_TAB_NAME = 'selfTopicTab'; // 导航模块

export const SELF_TOPIC_EXPERT = 'selfTopicExpert'; // 专家列表模块

export const SELF_TOPIC_BALL = 'selfTopicBall';

// 投票模块
export const COMMON_VOTE = 'vote';

// app吊起模块
export const COMMON_APP_INVOKE = 'appInvoke';

// 悬浮图片模块
export const COMMON_FLOAT_IMAGE = 'floatImage';

// 弹窗模块
export const SELF_POPUP = 'selfPopup';
